var Model = require("../types/Model.js");

module.exports = Model({
	name: "managedusersend",
	init: init,
	triggers,
});

function init() {
	this.push({
		isSearching: false,
		end: false
	});
}

function triggers() {
	return {
		"end": pushEnd,
		"search": startSearch,
		"search:end": endSearch
	};
}

function pushEnd(atEnd){
	this.extend({
		end: atEnd
	});
}

function startSearch(){
	this.extend({
		isSearching: true
	});
}

function endSearch(){
	this.extend({
		isSearching: false
	});
}